import { reactive } from 'vue'

export const auth = reactive({ user: null, ready: false, error: '' })
let token = localStorage.getItem('ai_token') || ''
let epoch = 0
let controller = new AbortController()

export const sessionToken = () => token
export const sessionEpoch = () => epoch
export const sessionSignal = () => controller.signal

export function setSession(nextToken, user) {
  controller.abort()
  controller = new AbortController()
  epoch++
  token = nextToken
  if (nextToken) localStorage.setItem('ai_token', nextToken)
  else { localStorage.removeItem('ai_token'); localStorage.removeItem('ai_user') }
  auth.user = user
}

export function expireSession(message = '') {
  setSession('', null)
  auth.error = message
}
